// extracted by mini-css-extract-plugin
export var highlightFade = "_2p-4";
export var highlighted = "_2p-3";
export var table = "_2p-1";
export var tableContainer = "_2p-0";
export var totalsRow = "_2p-2";